export default __webpack_public_path__ + "static/media/graphic-09.6adecbf3.png";